"use client";

import { useSyncExternalStore } from "react";
import { useTheme } from "next-themes";
import { useTranslations } from "next-intl";
import { Moon, Sun } from "../Common/Icons";

const subscribe = () => () => {};

/** True on the client after hydration, false during SSR and the hydration pass. */
const useMounted = () =>
  useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );

const ThemeToggler = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const t = useTranslations("component.navigation");
  // next-themes only knows the real theme on the client, so render a neutral
  // button until mounted to avoid a hydration mismatch.
  const mounted = useMounted();

  const isDark = mounted && resolvedTheme === "dark";

  return (
    <button
      type="button"
      aria-label={t("themeButton")}
      title={t("themeButton")}
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="inline-flex h-10 w-10 items-center justify-center rounded-full text-body-color transition hover:bg-gray-light hover:text-black dark:text-body-color-dark dark:hover:bg-white/10 dark:hover:text-white"
    >
      {mounted ? (
        isDark ? (
          <Sun size={18} />
        ) : (
          <Moon size={18} />
        )
      ) : (
        <span className="h-[18px] w-[18px]" />
      )}
    </button>
  );
};

export default ThemeToggler;
